import dayjs from 'dayjs';

export const DAY_OPENING_ENDPOINTS = {
  list: '/day/opening/list',
  start: '/day/opening/start',
  close: '/day/opening/close',
  restart: '/day/opening/restart'
};

export const DAY_ACTION_LABELS = {
  start: 'Day started successfully',
  close: 'Day closed successfully',
  restart: 'Day restarted successfully'
};

export function parseDayOpeningListResponse(res) {
  const data = res?.data?.data ?? res?.data;
  return Array.isArray(data) ? data : [];
}

export function isDayOpen(row) {
  return row?.close_time == null;
}

export function getOpenDay(rows) {
  return rows.find((row) => isDayOpen(row)) ?? null;
}

export function formatApiDate(val) {
  if (!val) return dayjs().format('YYYY-MM-DD');
  const d = dayjs(val);
  return d.isValid() ? d.format('YYYY-MM-DD') : String(val);
}

export function getActionPayload(action, openDay) {
  if (action === 'close' && openDay?.date) {
    return { date: formatApiDate(openDay.date) };
  }
  return { date: dayjs().format('YYYY-MM-DD') };
}

export function formatDayDateTime(val) {
  if (!val) return '—';
  const d = dayjs(val);
  return d.isValid() ? d.format('DD MMM YYYY, hh:mm A') : String(val);
}

export function getDayUserLabel(user) {
  if (!user) return '—';
  return user.username || user.email || user.name || '—';
}

export function getDayConfirmCopy(action) {
  if (action === 'close') {
    return {
      title: 'Close day',
      body: 'Close the current open day? New orders may be blocked until the day is restarted.',
      label: 'Close day'
    };
  }
  return {
    title: 'Restart day',
    body: 'Restart the day after it was closed? This opens a new session for today.',
    label: 'Restart day'
  };
}
